import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-617297fc")

_pushScopeId("data-v-617297fc")
const _hoisted_1 = { class: "layout-main tab-space ml-40 nr-40 grid mt-5" }
const _hoisted_2 = { class: "mw-60r" }
const _hoisted_3 = { class: "title text-3xl font font-normal" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-3 mt-3" }, null, -1)
const _hoisted_5 = { class: "flex items-center mt-4" }
const _hoisted_6 = { class: "w-3/5" }
const _hoisted_7 = { class: "flex items-center mt-4" }
const _hoisted_8 = { class: "w-3/5" }
const _hoisted_9 = { class: "flex items-center mt-4" }
const _hoisted_10 = { class: "w-3/5" }
const _hoisted_11 = { class: "flex items-center mt-4 w-full" }
const _hoisted_12 = { class: "w-full items-baseline flex justify-between" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "mt-6" }
const _hoisted_15 = { class: "text-center py-2" }
const _hoisted_16 = { class: "text-center ml-4" }
const _hoisted_17 = { class: "text-center ml-4" }
const _hoisted_18 = { class: "text-center ml-4" }
const _hoisted_19 = { class: "text-right flex justify-between mr-3" }
const _hoisted_20 = { class: "ml-3 card-number flex justify-center items-center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "pl-4 cursor-pointer" }, "×", -1)
const _hoisted_22 = { class: "action flex justify-center mt-8" }
const _hoisted_23 = { class: "popup-title flex justify-center mt-6 w-180" }
const _hoisted_24 = { class: "font-size-30" }
const _hoisted_25 = { class: "popup-body" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "staff-code flex mt-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "staff-code__text font-bold font-size-14 w-50" }, " スタッフコード "),
  /*#__PURE__*/_createVNode("div", { class: "staff-code__number font-size-16" }, "1001")
], -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "staff-name flex mt-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "staff-name__text w-50 font-bold font-size-14" }, " スタッフ名 "),
  /*#__PURE__*/_createVNode("div", { class: "staff-name__number font-size-16" }, "氏名")
], -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "affiliation-organization flex mt-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "affiliation-organization__text w-50 font-bold font-size-14" }, " 所属組織 "),
  /*#__PURE__*/_createVNode("div", { class: "affiliation-organization__number font-size-16" }, "人事課")
], -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "working-style flex mt-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "working-style__text w-50 font-bold font-size-14" }, " 就労形態 "),
  /*#__PURE__*/_createVNode("div", { class: "working-style__number font-size-16" }, "アルバイトA")
], -1)
const _hoisted_30 = { class: "ic-card mt-4" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "working-style__text w-50 font-bold font-size-14" }, " カード番号（IDｍ） ", -1)
const _hoisted_32 = { class: "working-style__number font-size-16 text-red-ff mt-2" }
const _hoisted_33 = { class: "c-card_form w-2/3 flex mt-4" }
const _hoisted_34 = { class: "w-full" }
const _hoisted_35 = { class: "flex justify-center mt-12 mb-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Label = _resolveComponent("Label")
  const _component_Select = _resolveComponent("Select")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")
  const _component_Input = _resolveComponent("Input")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('iCCardRegistration')), 1),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Label, {
              "text-label": _ctx.t('affiliationOrganization')
            }, null, 8, ["text-label"]),
            _createVNode(_component_Select, {
              "options-select": _ctx.affiliationOrganizationOption,
              validated: _ctx.validated,
              required: "",
              itemText: 'text'
            }, null, 8, ["options-select", "validated"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Label, {
              "text-label": _ctx.t('workingStyle')
            }, null, 8, ["text-label"]),
            _createVNode(_component_Select, {
              "options-select": _ctx.workingStyleOption,
              validated: _ctx.validated,
              required: "",
              itemText: 'text'
            }, null, 8, ["options-select", "validated"])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_Label, {
              "text-label": _ctx.t('cardRegistration.staff')
            }, null, 8, ["text-label"]),
            _createVNode(_component_Select, {
              placeholder: _ctx.t('placeholderSelect'),
              "options-select": _ctx.workingStyleOption,
              validated: _ctx.validated,
              required: "",
              "item-value": ''
            }, null, 8, ["placeholder", "options-select", "validated"])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Checkbox, {
              classes: "mr-5 custom-checkbox",
              "option-checkbox": {
              label: _ctx.t('cardRegistration.icCardUnregisteredOnly'),
            }
            }, null, 8, ["option-checkbox"]),
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_Button, { class: "btn-outline-blue h-12 w-40 mr-3" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('cardRegistration.import')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Button, { class: "btn-outline-blue h-12 w-40" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('export')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_Table, {
            data: _ctx.cardRegistrationData,
            headers: _ctx.cardRegistrationHeaders,
            fixedHeader: "",
            class: "max-h-62"
          }, {
            staff_code: _withId(({ item }) => [
              _createVNode("div", _hoisted_15, _toDisplayString(item.staff_code), 1)
            ]),
            staff_name: _withId(({ item }) => [
              _createVNode("div", _hoisted_16, _toDisplayString(item.staff_name), 1)
            ]),
            affiliation_organization: _withId(({ item }) => [
              _createVNode("div", _hoisted_17, _toDisplayString(item.affiliation_organization), 1)
            ]),
            working_style: _withId(({ item }) => [
              _createVNode("div", _hoisted_18, _toDisplayString(item.working_style), 1)
            ]),
            action: _withId(({ index }) => [
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("span", null, _toDisplayString(_ctx.t('cardRegistration.numberCardExample')), 1),
                  _hoisted_21
                ]),
                _createVNode("span", {
                  onClick: ($event: any) => (_ctx.showPopupSelect(index)),
                  class: "cp-icon-plus-circle cursor-pointer text-3xl text-red-ff"
                }, null, 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["data", "headers"])
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode(_component_Button, { class: "w-50 h-12 btn-gradation-light-blue mr-5" }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('toRegister')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, { class: "btn-gradation-secondary w-50 h-12" }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      modelValue: _ctx.isShow,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShow = $event)),
      classes: "size-xs-popup",
      persistent: ""
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_23, [
          _createVNode("p", _hoisted_24, _toDisplayString(_ctx.t('iCCardRegistration')), 1)
        ]),
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          _hoisted_28,
          _hoisted_29,
          _createVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode("div", _hoisted_32, _toDisplayString(_ctx.t('cardRegistration.cardRegistrationInputText')), 1)
          ]),
          _createVNode("div", _hoisted_33, [
            _createVNode("div", _hoisted_34, [
              _createVNode(_component_Input)
            ]),
            _createVNode(_component_Button, { class: "btn-purple w-50 h-12 ml-4" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('cardRegistration.connectPaSoRi')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode(_component_Button, {
            onClick: _ctx.saveSelectedOrganization,
            class: "btn-gradation-light-blue w-50 h-12 mr-4"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('select')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            onClick: _ctx.hiddenPopupSelect,
            class: "btn-gradation-secondary w-50 h-12"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})